<template>
    <div>
        <header-slot></header-slot>
        <b-card>
            <AreasModuleTable />
        </b-card>
    </div>
</template>
<script>
import AreasModuleTable from "@/views/settings/views/areas-module/components/AreasModuleTable.vue"
export default {
    components: {
        AreasModuleTable
    }
}
</script>
